import { render } from "./GetSiteNavigation.vue?vue&type=template&id=3fce7aa2&scoped=true"
import script from "./GetSiteNavigation.vue?vue&type=script&lang=js"
export * from "./GetSiteNavigation.vue?vue&type=script&lang=js"

import "./GetSiteNavigation.vue?vue&type=style&index=0&id=3fce7aa2&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fce7aa2"],['__file',"src/scripts/view/portfolio/sections/_helper/GetSiteNavigation.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3fce7aa2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3fce7aa2', __exports__)) {
    api.reload('3fce7aa2', __exports__)
  }
  
  module.hot.accept("./GetSiteNavigation.vue?vue&type=template&id=3fce7aa2&scoped=true", () => {
    api.rerender('3fce7aa2', render)
  })

}


export default __exports__